// =============================================================================
// relance-journal-client.http.ts — Adaptateur HTTP RÉEL du RelanceJournalClient (R15-COM-05).
// =============================================================================
// DBU §2.7.1. Câble le journal des relances derrière le MÊME DI seam (RelanceJournalClientProvider) :
// l'écran consomme l'interface, l'impl est substituée sans toucher l'UI.
//
// AUTORITÉ = API (NestJS, AdminSessionGuard). Cet adaptateur ne porte AUCUNE règle métier : GET, parse,
// mappe l'erreur. SÉCURITÉ : session admin = COOKIE httpOnly (credentials: 'include'). LECTURE (GET) ⇒
// aucun en-tête CSRF requis (le double-submit ne protège que les mutations).

import {
  RelanceJournalApiError,
  type RelanceJournalClient,
  type RelanceJournalResponseDto,
} from '@/api/relance-journal-client';

/** Forme attendue d'un corps d'erreur structuré (NestJS HttpException). */
interface StructuredErrorBody {
  readonly statusCode?: number;
  readonly message?: string;
}

export class HttpRelanceJournalClient implements RelanceJournalClient {
  public constructor(private readonly baseUrl: string = '/api') {}

  public async fetchJournal(
    campaignId: string,
  ): Promise<RelanceJournalResponseDto> {
    const response = await fetch(
      `${this.baseUrl}/admin/campaigns/${encodeURIComponent(campaignId)}/relances`,
      {
        method: 'GET',
        credentials: 'include',
        headers: { accept: 'application/json' },
      },
    );
    if (!response.ok) {
      throw await this.toApiError(response);
    }
    return (await response.json()) as RelanceJournalResponseDto;
  }

  /** Convertit une réponse non-OK en erreur applicative typée (message serveur tel quel + statut). */
  private async toApiError(response: Response): Promise<RelanceJournalApiError> {
    let body: StructuredErrorBody | undefined;
    try {
      body = (await response.json()) as StructuredErrorBody;
    } catch {
      body = undefined;
    }
    const message =
      body?.message ??
      `Erreur API (${String(response.status)}) sur le journal des relances.`;
    return new RelanceJournalApiError(message, response.status);
  }
}
